import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import AppLogo from './../../../assets/img/brand/logo.jpeg';
import { authActionTypes } from '@store/Auth/Auth.actionTypes';
import firebase from '@config/firebase.config';
import { addNotification, notificationStates } from '@/components/Notification';
const database = firebase.firestore();
const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const memberRef = await database
        .collection('membersDatabase')
        .where('accountEmailid', '==', email)
        .get();
      if (memberRef.docs.length > 0) {
        const memberData = memberRef.docs[0].data();
        dispatch({
          type: authActionTypes.FORGOT_PASSWORD,
          payload: { email, fullName: memberData.accountFullName },
        });
      } else {
        addNotification({
          message: 'Email not found in our system',
          level: notificationStates.error,
        });
      }
    } catch (error) {
      addNotification({
        message: 'Failed to send reset email',
        level: notificationStates.error,
      });
    }
  };

  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardHeader className="bg-transparent pb-2 border-0">
          <div className="text-center">
            <img className="auth-app-logo" src={AppLogo} alt="workfromhome" />
          </div>
          <div className="text-muted text-center mt-2 mb-3">
            <h2>Reset Password</h2>
            <small>Enter your email to reset your password</small>
          </div>
        </CardHeader>
        <CardBody className="px-lg-5 py-lg-4">
          <Form role="form" onSubmit={handleSubmit}>
            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-email-83" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>
            <div className="text-center">
              <Button
                className="my-4"
                color="primary"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
      <div className="pb-5 pt-2 text-center">
        <small className="text-white">
          {' '}
          Remember your password ?{' '}
          <Link className="font-weight-bold text-white" to={'/auth/login'}>
            Sign in
          </Link>
        </small>
      </div>
    </Col>
  );
};

export default ForgotPassword;
